/* eslint-disable */
require('./folder')
require('./github')
require('./home')
require('./linkedin')
require('./mail')
require('./person')
require('./phone')
require('./quote')
require('./school')
require('./send')
require('./wizhat')
require('./work')



// WEBPACK FOOTER //
// ./src/icons/index.js